import React, { useState, useEffect } from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import { savePaymentMethod } from '../slices/cartSlice';
import CheckoutSteps from '../components/CheckoutSteps';
import { useTranslation } from 'react-i18next';

const PaymentScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir().toLowerCase() === 'rtl';

  const { deviseInfo } = useSelector((state) => state.devise);
  const currency = typeof deviseInfo === 'string' ? deviseInfo : 'EUR';

  const [paymentMethod, setPaymentMethod] = useState(
    currency === 'TND' ? 'ClicToPay' : 'Stripe'
  );

  useEffect(() => {
    if (!shippingAddress) {
      navigate('/shipping');
    }
  }, [shippingAddress, navigate]);

  useEffect(() => {
    if (currency === 'TND') {
      setPaymentMethod('ClicToPay');
    } else if (paymentMethod === 'ClicToPay') {
      setPaymentMethod('Stripe');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    navigate('/placeorder');
  };

  return (
    <FormContainer wide>
      <CheckoutSteps step1 step2 step3 />
      <h1 dir={isRTL ? 'rtl' : 'ltr'}>{t('mode')}</h1>
      <Form onSubmit={submitHandler} dir={isRTL ? 'rtl' : 'ltr'}>
        <Form.Group>
          <Form.Label as='legend'>{t('method')}</Form.Label>

          {currency === 'TND' && (
            <Col>
              <Form.Check
                type='radio'
                className='my-2'
                label='ClictoPay Tunisia'
                id='ClicToPay'
                name='paymentMethod'
                value='ClicToPay'
                checked={paymentMethod === 'ClicToPay'}
                onChange={(e) => setPaymentMethod(e.target.value)}
              />
            </Col>
          )}

          {(currency === 'EUR' || currency === 'USD') && (
            <Col>
              <Form.Check
                type='radio'
                className='my-3'
                label='Carte Bancaire (Stripe)'
                id='Stripe'
                name='paymentMethod'
                value='Stripe'
                checked={paymentMethod === 'Stripe'}
                onChange={(e) => setPaymentMethod(e.target.value)}
              />

              <Form.Check
                type='radio'
                className='my-3'
                label='PayPal'
                id='PayPal'
                name='paymentMethod'
                value='PayPal'
                checked={paymentMethod === 'PayPal'}
                onChange={(e) => setPaymentMethod(e.target.value)}
              />
            </Col>
          )}
        </Form.Group>
        <br />
        <Button type='submit' className='btn-teal w-100'>
          {t('Continue')}
        </Button>
      </Form>
    </FormContainer>
  );
};

export default PaymentScreen;
